if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // Atelier: html classes that follow [open], however it changes (at-lightbox.css: no buy bar or chat pill over the
        // photos, no scrollbar gutter). They were :has(product-modal[open]) on <html> and <body>, which made every
        // [open] change on the page (each accordion) restyle all of it. The observer runs before the next frame.
        new MutationObserver(() => ProductModal.syncOpen()).observe(this, { attributes: true, attributeFilter: ['open'] });
      }

      static syncOpen() {
        const root = document.documentElement;
        root.classList.toggle('at-pm-open', Boolean(document.querySelector('product-modal[open]')));
        root.classList.toggle('at-lb-open', Boolean(document.querySelector('product-modal[data-at-lightbox][open]')));
      }

      disconnectedCallback() {
        ProductModal.syncOpen(); // removed while open (the theme editor re-renders the section)
      }

      // Atelier: on phones, where the gallery is a swiped strip, closing leaves the strip on the photo she was last
      // looking at in the lightbox (moved at once, under the closing fade) and returns focus to that photo. It stayed on
      // the photo she had opened, so the fade dissolved one photo into another. On computers (a grid) it stays put: a
      // later photo can be far down the page.
      hide() {
        const lightbox = this.querySelector('at-lightbox');
        const slide = lightbox?.slides?.[lightbox.index];
        const opener = slide && document.querySelector(`media-gallery .product__media-toggle[data-media-id="${slide.dataset.mediaId}"]`);
        const item = opener?.closest('li');
        const strip = item?.parentElement;
        if (opener && opener !== this.openedBy && strip.scrollWidth > strip.clientWidth && item.getClientRects().length) {
          strip.scrollTo({ left: strip.scrollLeft + item.getBoundingClientRect().left - strip.getBoundingClientRect().left, behavior: 'instant' });
          this.openedBy = opener;
        }
        // The lightbox keeps its width while it fades out: closing gives the page back its scrollbar space
        // (html.at-lb-open goes), which on computers with always-visible scrollbars narrowed the fading viewer by 15px
        // and moved its photo sideways. The page behind settles under the still-opaque start of the fade.
        const keep = this.hasAttribute('data-at-lightbox') && this.getBoundingClientRect().width;
        if (keep) {
          this.style.right = 'auto';
          this.style.width = keep + 'px';
        }
        super.hide();
        if (!keep) return;
        const release = () => {
          this.style.removeProperty('right');
          this.style.removeProperty('width');
        };
        const fades = this.getAnimations().filter((a) => a.transitionProperty === 'opacity');
        if (fades.length) Promise.all(fades.map((a) => a.finished)).then(release, release);
        else release(); // Reduce Motion: no fade
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        // Atelier: focus starts on Close (trapFocus parked it on the dialog itself)
        this.querySelector('[id^="ModalClose-"]')?.focus();
      }

      // Atelier: open the lightbox (<at-lightbox>, assets/at-lightbox.js) on the slide whose data-media-id matches
      // the gallery opener's.
      showActiveMedia() {
        const slides = Array.from(this.querySelectorAll('.at-lb-slide'));
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const index = Math.max(0, slides.findIndex((slide) => slide.dataset.mediaId === mediaId));
        const lightbox = this.querySelector('at-lightbox');
        if (lightbox?.show) lightbox.show(index);

        const activeMedia = slides[index]?.querySelector('deferred-media');
        const template = activeMedia?.querySelector('template');
        if (template && template.content.querySelector('.js-youtube')) activeMedia.loadContent();
      }
    }
  );
}
